import React from 'react';
import { Redirect,useLocation } from 'react-router-dom';

import useAuth from '../../hooks/useAuth';
import Unauthorized from 'views/maintenance/Unauthorized';

const AuthGuard2 = ({ children }) => {
    const { isLoggedIn } = useAuth();
    
    if (!isLoggedIn) {
        return <Redirect to="/auth/signin-1" />;
    }

    return (
        <React.Fragment>
            {children}
        </React.Fragment>
    );
};


const AuthGuard = ({ state,children }) => {
    const location = useLocation();
    const pathFromHash = location.pathname;
    const { isLoggedIn,user,config,perspective } = useAuth(); // Assuming userPermissions is available
    let userPermissions = user.permissions || []
    let routePermissions = state?.permissions || [];
    const routePath = pathFromHash || null;
    const statePath = state.path || null

    if (!isLoggedIn) {
        return <Redirect to="/maintenance/unauthorized" />;
    }

    const pathSegments = pathFromHash.split('/');
    let allowPerspective = !(pathSegments.length>1 && pathSegments[1].trim()!='' )
    
    if(routePath){
        const find = config.find(({configCode})=>configCode==='menu_visible')
        if(find){
            find.jsonData.permissions.forEach((permission)=>{
                permission?.perspective?.forEach((per)=>{
                    if(per){
                        //const routePerm = per.paths.includes(routePath)
                        const routePerm = per.paths.some(path => routePath.startsWith(path));
                        //console.log('loop',routePath,routePerm,permission)
                        if(routePerm){
                            //console.log('found',permission)
                            routePermissions.push(permission.role)    
                        }else if(per?.relatedPaths){
                            const routePerm = per.relatedPaths.some(path => routePath.startsWith(path));
                            //console.log('loop',routePath,routePerm,permission)
                            if(routePerm){
                                //console.log('found',permission)
                                routePermissions.push(permission.role)    
                            }
                        }

                        if(!allowPerspective && per.routePath){        
                            allowPerspective = pathFromHash.startsWith(per.routePath)
                        }
                    }
                })
            })            
        }
    }

    
    
    

    const hasPermission = allowPerspective && (routePermissions.some(permission => userPermissions.includes(permission)) || userPermissions.includes('role:ckdoctor:admin') || statePath==='*' || routePath==='/')

    //console.log("auth.user",hasPermission,userPermissions);
    //console.log("auth.config",routePath,location,routePermissions,state)
    if (!hasPermission ) {
        return <React.Fragment><Unauthorized/></React.Fragment>; // Redirect to an unauthorized page or handle accordingly
    }

    return <React.Fragment>{children}</React.Fragment>;
};

export default AuthGuard;
